export enum HttpErrorCode {
  NOT_FOUND = 404,
  INTERNAL_SERVER_ERROR = 500,
}
